import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { BlockAlign } from '../../../../models/BlockSettings';

interface BlockAlignPickerProps {
  value: BlockAlign;
  direction: 'row' | 'column';
  hasStretch?: boolean;
  onChangeAlign: (value: BlockAlign) => void;
}

const BlockAlignPicker = ({
  value, direction, hasStretch = true, onChangeAlign,
}: BlockAlignPickerProps) => (
  <Box>
    {direction === 'column' ? 'Alignment' : 'Vertical position'}
    <ToggleButtonGroup
      color="primary"
      value={value}
      exclusive
      onChange={(_, newValue: BlockAlign) => {
        if (newValue) {
          onChangeAlign(newValue);
        }
      }}
      size="small"
      sx={{ marginLeft: 3 }}
    >
      <ToggleButton value={BlockAlign.START} sx={{ paddingX: 2, paddingY: 1 }}>{direction === 'column' ? 'Left' : 'Top'}</ToggleButton>
      <ToggleButton value={BlockAlign.CENTER} sx={{ paddingX: 2, paddingY: 1 }}>{direction === 'column' ? 'Center' : 'Center'}</ToggleButton>
      <ToggleButton value={BlockAlign.END} sx={{ paddingX: 2, paddingY: 1 }}>{direction === 'column' ? 'Right' : 'Bottom'}</ToggleButton>
      {hasStretch && <ToggleButton value={BlockAlign.STRETCH} sx={{ paddingX: 2, paddingY: 1 }}>{direction === 'column' ? 'Full' : 'Full height'}</ToggleButton>}
    </ToggleButtonGroup>
  </Box>
);

export default BlockAlignPicker;
